import { useState } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { aboutData } from '@/mocks/articles';
import { get_form_url } from '@/utils/formHelper';

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: aboutData.brandName,
            description: aboutData.introduction,
            url: 'https://plushy.cn',
            contactPoint: {
              '@type': 'ContactPoint',
              email: aboutData.contact.email,
              contactType: 'customer service',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://plushy.cn/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://plushy.cn/about' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '朝桐光官方粉丝资讯站是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '朝桐光官方粉丝资讯站创立于2020年，是朝桐光在中国及亚洲地区最权威的粉丝资讯平台，提供最新资讯、作品介绍、写真图集和粉丝社区。',
                },
              },
              {
                '@type': 'Question',
                name: '如何加入粉丝社区？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过网站注册成为会员，或关注我们的官方微博、微信公众号获取最新信息。社区对所有喜爱朝桐光的粉丝开放。',
                },
              },
              {
                '@type': 'Question',
                name: '朝桐光有哪些代表作品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '朝桐光的代表作品包括电影《东京夜曲》（获横滨电影节最佳女演员奖）、《樱花之约》，以及日剧《京都恋歌》等。',
                },
              },
            ],
          }),
        }}
      />

      <div className="min-h-screen pt-16">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-6 md:py-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                关于我们
              </h1>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                了解朝桐光官方粉丝资讯站的故事与使命
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12">
              {aboutData.achievements.map((item) => (
                <div key={item.label} className="text-center p-4 md:p-6 rounded-lg bg-background-100">
                  <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600 mb-1">
                    {item.number}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 mb-12">
              <div>
                <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-4">
                  品牌故事
                </h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  {aboutData.introduction}
                </p>
                <div className="p-4 rounded-lg bg-accent-50 border border-accent-100">
                  <p className="text-sm text-accent-800 font-medium flex items-start gap-2">
                    <i className="ri-double-quotes-l text-accent-400 mt-0.5"></i>
                    {aboutData.mission}
                  </p>
                </div>
              </div>

              <div>
                <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-4">
                  团队介绍
                </h2>
                <p className="text-sm text-foreground-700 leading-relaxed">{aboutData.teamIntro}</p>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-6 text-center">
                粉丝口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {aboutData.testimonials.map((item, i) => (
                  <div
                    key={i}
                    className="p-5 rounded-lg bg-background-50 border border-background-200/70"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {[...Array(5)].map((_, j) => (
                        <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4 italic">
                      "{item.content}"
                    </p>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.author}</p>
                      <p className="text-xs text-foreground-400">{item.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div id="contact" className="max-w-2xl mx-auto">
              <div className="text-center mb-6">
                <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500">
                  有任何问题或建议，欢迎随时与我们联系
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">电子邮箱</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-weibo-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">官方微博</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.weibo}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">微信公众号</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.wechat}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-100 text-foreground-500 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">办公地址</p>
                    <p className="text-sm text-foreground-800">{aboutData.contact.address}</p>
                  </div>
                </div>
              </div>

              <ContactForm />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData(form);
      const formUrl = await get_form_url();
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setSubmitted(true);
        form.reset();
      } else {
        const serverMsg =
          (parsed && ((parsed as Record<string, unknown>).meta as Record<string, unknown>)?.message) ||
          (parsed && (parsed as Record<string, unknown>).message) ||
          responseText ||
          '提交失败，请稍后重试';
        setError(String(serverMsg));
      }
    } catch {
      setError('网络错误，请检查连接后重试');
    } finally {
      setLoading(false);
    }
  };

  const [formUrlLoaded, setFormUrlLoaded] = useState(false);

  return (
    <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">发送消息</h3>

      {submitted ? (
        <div className="text-center py-8">
          <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-check-line text-2xl text-primary-600"></i>
          </div>
          <p className="text-sm text-foreground-700 font-medium">消息已发送！</p>
          <p className="text-xs text-foreground-500 mt-1">感谢您的来信，我们会尽快回复。</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} data-readdy-form="">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
            <div>
              <label htmlFor="contact-name" className="block text-xs text-foreground-500 mb-1">
                姓名 <span className="text-primary-500">*</span>
              </label>
              <input
                id="contact-name"
                name="name"
                type="text"
                required
                className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="您的姓名"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-xs text-foreground-500 mb-1">
                邮箱 <span className="text-primary-500">*</span>
              </label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                placeholder="your@email.com"
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="contact-subject" className="block text-xs text-foreground-500 mb-1">
              主题
            </label>
            <input
              id="contact-subject"
              name="subject"
              type="text"
              className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
              placeholder="消息主题"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="contact-message" className="block text-xs text-foreground-500 mb-1">
              消息 <span className="text-primary-500">*</span>
            </label>
            <textarea
              id="contact-message"
              name="message"
              required
              maxLength={500}
              rows={4}
              className="w-full px-3 py-2 text-sm border border-background-300 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
              placeholder="请输入您的消息（最多500字）"
            ></textarea>
          </div>
          {error && (
            <p className="text-xs text-red-600 mb-3">{error}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full px-5 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-sans hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
          >
            {loading ? '发送中...' : '发送消息'}
          </button>
        </form>
      )}
    </div>
  );
}